import React from "react";
import { DialogButton, DialogConfig, createDialogConfig } from "common/component/SequentialDialog";
import { createButton } from "./utils";

const createContent = (): React.ReactNode => (
  <div>You are submitting a report for an authorization that is Inactive. Do you want to continue?</div>
);

const createButtons = (): DialogButton[] => [
  createButton('Submit', { action: 'submit', continueWithInactive: true })
];

export const createInactiveAuthDialogConfig = (shouldShow: boolean): DialogConfig => {
  return createDialogConfig(
    'inactive-auth-warning',
    'Confirm!',
    createContent(),
    createButtons(),
    shouldShow
  );
};
